import {toJS} from "mobx";
import wallet from "../assets/img/cards/MONEDERO.svg";
import walletAlt from "../assets/img/cards/MONEDERO_ALT.svg";
import star from "../assets/img/cards/FAVORITOS.svg";
import starAlt from "../assets/img/cards/FAVORITOS_ALT.svg";
import bici from "../assets/img/cards/BICI.svg";
import biciAlt from "../assets/img/cards/BICI_ALT.svg";
import boleto from "../assets/img/cards/boleto.svg";
import boletoAlt from "../assets/img/cards/boletoAlt.svg";
import claims from "../assets/img/cards/RECLAMACIONES.svg";
import claimsAlt from "../assets/img/cards/RECLAMACIONES_ALT.svg";
import cardTib from "../assets/img/TargetaGeneral.svg";
import moment from "moment";
import i18n from 'i18next';

export const parseDate = (date: string | Date, full?: boolean): string => {
  if (!date) return "";
  const parsed = new Date(date);
  if (!full) {
    return (
        ("0" + parsed.getDate()).slice(-2) +
        "/" +
        ("0" + (parsed.getMonth() + 1)).slice(-2) +
        "/" +
        parsed.getFullYear()
    );
  } else {
    return (
        ("0" + parsed.getDate()).slice(-2) +
        "/" +
        ("0" + (parsed.getMonth() + 1)).slice(-2) +
        "/" +
        parsed.getFullYear() +
        "  " +
        ("0" + parsed.getHours()).slice(-2) +
        ":" +
        ("0" + parsed.getMinutes()).slice(-2)
    );
  }
};

export const capitalizeMenuString = (chain: string) => {
  return chain
      .toLowerCase()
      .replace("/", " ")
      .replace(/^\w/, (c) => c.toUpperCase());
};

export const showSnackbar = (error?: boolean) => {
  let x: any = document.getElementById(`snackbar${error ? '-error' : ''}`);
  x.className = "show";
  setTimeout(() => {
    x.className = x.className.replace("show", "");
  }, 3000);
};

export const getEntityOfIsland = (island: string) => {
  switch (island) {
    case "Mallorca":
      return "ctmr4";
    case "Menorca":
      return "cime";
    case "Ibiza":
    case "Eivissa":
      return "cie";
    default:
      return "ctmr4";
  }
}

export const getIslandOfEntity = (island: string) => {
  switch (island) {
    case "ctmr4":
      return "Mallorca";
    case "cime":
      return "Menorca";
    case "cie":
      return i18n.t("ibiza.name");
    default:
      return island;
  }
}

export const setEntities = (island: string) => {
  switch (island) {
    case "ctmr4":
      localStorage.setItem("entity", "ctmr4");
      localStorage.setItem("entityId", "4");
      break;
    case "cime":
      localStorage.setItem("entity", "cime");
      localStorage.setItem("entityId", "2");
      break;
    case "cie":
      localStorage.setItem("entity", "cie");
      localStorage.setItem("entityId", "3");
      break;
    default:
      localStorage.setItem("entity", "ctmr4");
      localStorage.setItem("entityId", "4");
      break;
  }
}

export const getNextDiscount = (points: number, bonusesResident: number) => {
  const discount = (bonusesResident / 100) * points;
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR"
  }).format(Math.round(discount * 100) / 100);
}

export const getActualDate = () => {
  let today = new Date().toISOString();
  return today.slice(0, today.length - 5);
};

export const parseAmount = (money: number) => {
  const parsed = money / 100;
  return new Intl.NumberFormat("es-ES", {style: "currency", currency: "EUR"}).format(Math.round(parsed * 100) / 100);
};

export const showHeaderCards = (url: string) => {
  switch (url) {
    case "/profile":
      return true;
    case "/notifications":
      return true;
    default:
      return true;
  }
};

export const getBreadcrumbs = (location: string) => {
  let base = [{url: "/wallet", label: i18n.t("breadcrumbs.home")}];
  if (location !== "/wallet") {
    base.push({
      url: location,
      label: i18n.t(`breadcrumbs.${location.slice(1, location.length)}`),
    });
  }
  return base;
};

export const getCardSvg = () => {
    return cardTib;
};

export const getCardConfig = (card: string) => {
  let config = {color: '#002e6d'};
  switch (card) {
    case "wallet":
      return {...config, icon: wallet, iconAlt: walletAlt};
    case "favorites":
      return {...config, icon: star, iconAlt: starAlt};
    case "next-travel":
      return {...config, icon: boleto, iconAlt: boletoAlt};
    case "moutebe":
      return {...config, icon: bici, iconAlt: biciAlt};
    case "claims":
      return {...config, icon: claims, iconAlt: claimsAlt};
    default:
      break;
  }
};

export const getHours = (nextHours: Array<any>) => {
  return nextHours.map((h) => {
    const hour = h.aet.split("T")[1];
    const time = moment().diff(h.aet, 'minutes');
    return {
      ...h,
      aet: time <= -59 ? `${hour.slice(0, hour.length - 3)} h` : `${time.toString().slice(1, time.toString().length)} ${i18n.t('minutes')}`
    }
  });
};

export const getAge = (birthdate: string | Date): number => {
  return moment(new Date()).diff(moment(birthdate), 'years')
};

export const getAgeNumber = (birthdate: any) => {
  var ageNum = 0;
  if (birthdate !== null && birthdate !== undefined && birthdate !== "") {
    var a = moment();
    var b = moment(birthdate, "YYYY");
    ageNum = a.diff(b, "years");
    if (ageNum !== null && ageNum !== undefined) {
      return ageNum;
    }
  }
  return ageNum;
};

export const parseHeadersTable = (
    array: Array<any>,
    show: Array<string>,
    showAction?: boolean
) => {
  const parsedHeaders: Array<any> = [];
  const headers = Object.keys(toJS(array)[0]);
  headers.forEach((h) => {
    if (show.indexOf(h) > -1) {
      let parsed = {id: h, label: i18n.t(`headers.${h}`)};
      parsedHeaders.push(parsed);
    }
  });
  if (showAction) parsedHeaders.push({id: "action", label: ""});
  return parsedHeaders;
};

export const parseChildHeaders = (array: Array<any>) => {
  const childHeaders: Array<any> = [];
  for (let item of array) {
    if (
        item.info &&
        item.info.data &&
        item.info.data.cancellations &&
        item.info.data.cancellations.length > 0
    ) {
      Object.keys(item.info.data.cancellations[0]).forEach((h: any) => {
        let parsed = {id: h, label: i18n.t(`headers.${h}`)};
        childHeaders.push(parsed);
      });
      break;
    }
  }
  return childHeaders;
};

export const getClaimState = (id: number) => {
  switch (id) {
    case 0:
      return `${i18n.t('claims_state.received')}`;
    case 1:
      return `${i18n.t('claims_state.transit')}`;
    case 2:
      return `${i18n.t('claims_state.closed')}`;
    case 3:
      return `${i18n.t('claims_state.discard')}`;
  }
}

export const isMobile = () => {
  return window.screen.width <= 768;
};

export const isYoungProfile = (birthdate: string | Date) => {
  if (getAgeNumber(birthdate) >= 17 && getAgeNumber(birthdate) <= 31) {
    return true;
  } else {
    return false;
  }
};